import React from 'react';
import { Navigate } from 'react-router';

import { SYSTEM_ADMIN_ROUTES } from '../constants';

import dashboardRoutes from '../components/CMS/SystemAdmin/Dashboard/routes';
import cePacksRoutes from '../components/CMS/SystemAdmin/CEPacks/routes';
import profileRoutes from '../components/CMS/SystemAdmin/Profile/Routes';
import designationElementsRoutes from '../components/CMS/SystemAdmin/DesignationElements/routes';
import testsRoutes from '../components/CMS/SystemAdmin/Tests/routes';
import certificatesRoutes from '../components/CMS/SystemAdmin/Certificates/routes';
import licenseesRoutes from '../components/CMS/SystemAdmin/Licensees/routes';
import surveyRoutes from '../components/CMS/SystemAdmin/Surveys/routes';
import organizationsRoutes from '../components/CMS/SystemAdmin/Organizations/routes';
import usersRoutes from '../components/CMS/SystemAdmin/Users/routes';
import sellingGroupsRoutes from '../components/CMS/SystemAdmin/SellingGroups/routes';
import sellingGroupCategoriesRoutes from '../components/CMS/SystemAdmin/SellingGroupCategories/routes';
import instructorsRoutes from '../components/CMS/SystemAdmin/Instructors/routes';
import trainingProducts from '../components/CMS/SystemAdmin/TrainingProducts/routes';
import productTypesRoutes from '../components/CMS/SystemAdmin/ProductTypes/routes';
import couponsRoutes from '../components/CMS/SystemAdmin/Coupons/routes';
import vouchersRoutes from '../components/CMS/SystemAdmin/Vouchers/routes';
import ordersRoutes from '../components/CMS/SystemAdmin/Orders/routes';
import orderRefundRoutes from '../components/CMS/SystemAdmin/OrderRefund/routers';
import eventCreditRoutes from '../components/CMS/SystemAdmin/EventCredits/routes';
import shipmentRoutes from '../components/CMS/SystemAdmin/Shipments/routes';
import acceptYourSeatsRoutes from '../components/CMS/Guest/AcceptYourSeat/routes';
import verifySeatRoutes from '../components/CMS/Guest/VerifySeat/routes';
import surveyReportsRoutes from '../components/CMS/SystemAdmin/SurveyReports/routes';
import contentManagements from '../components/CMS/SystemAdmin/ContentManagement/routes';
import redisRoutes from '../components/CMS/SystemAdmin/Redis/routes';
import shippingReportsRoutes from '../components/CMS/SystemAdmin/ShippingReports/routes';
import ceReportsRoutes from '../components/CMS/SystemAdmin/CeReports/routes';
import designationReportsRoutes from '../components/CMS/SystemAdmin/DesignationReports/routes';
import orderReportsRoutes from '../components/CMS/SystemAdmin/OrderReports/routes';
import hubSpotIntegrations from '../components/CMS/SystemAdmin/Integrations/router';
import bundledSeatsRoutes from '../components/CMS/SystemAdmin/BundledSeats/router';
import sowOrdersRoutes from '../components/CMS/Shared/SOWOrders/routes';
import trainingProductReportsRoutes from '../components/CMS/SystemAdmin/TrainingProductReports/routes';
import organizationTrainingReportsRoutes from '../components/CMS/SystemAdmin/OrganizationTrainingReport/routes';
import seatAvailabilityReportsRoutes from '../components/CMS/SystemAdmin/SeatAvailabilityReports/routers';
import sowTotalOrderReportsRoutes from '../components/CMS/SystemAdmin/SOWReports/SOWTotalOrderReports/routes';
import sowTrainingUsageReportsRoutes from '../components/CMS/SystemAdmin/SOWReports/SOWTrainingUsageReports/routes';

// A route object has the same properties as a <Route>
// element. The `children` is just an array of child routes.
const systemAdminRoutes = [
     dashboardRoutes,
     cePacksRoutes,
     licenseesRoutes,
     profileRoutes,
     designationElementsRoutes,
     testsRoutes,
     certificatesRoutes,
     surveyRoutes,
     trainingProducts,
     sellingGroupsRoutes,
     sellingGroupCategoriesRoutes,
     instructorsRoutes,
     productTypesRoutes,
     couponsRoutes,
     vouchersRoutes,
     trainingProducts,
     ordersRoutes,
     orderRefundRoutes,
     eventCreditRoutes,
     shipmentRoutes,
     organizationsRoutes,
     usersRoutes,
     acceptYourSeatsRoutes,
     verifySeatRoutes,
     surveyReportsRoutes,
     contentManagements,
     redisRoutes,
     shippingReportsRoutes,
     ceReportsRoutes,
     designationReportsRoutes,
     orderReportsRoutes,
     hubSpotIntegrations,
     bundledSeatsRoutes,
     sowOrdersRoutes,
     trainingProductReportsRoutes,
     organizationTrainingReportsRoutes,
     seatAvailabilityReportsRoutes,
     sowTotalOrderReportsRoutes,
     sowTrainingUsageReportsRoutes,
     {
          path: '*',
          element: <Navigate to={SYSTEM_ADMIN_ROUTES} />,
     },
];

export default systemAdminRoutes;
